<template>

    <div class="card shadow mt-2 mb-3 border-danger bg-danger bg-opacity-10">
      <div class="card-body">
        <div class="title">
          <h5 class="text-danger">Опасная зона</h5>
        </div>
        <div class="border border-danger border-opacity-50 bg-danger bg-opacity-10 d-flex p-3 rounded">
          <div class="title">
            <div>
              <strong>Удалить проект</strong><br>
              <div class="sub-title">Безвозвратное удаление проекта и всех данных</div>
            </div>
          </div>
          <button class="btn btn-danger ms-auto brn-sm" @click="$modal('show', 'delete_project')">Удалить</button>
        </div>
      </div>
          <modal modal_id="delete_project">
        <template v-slot:header>
          <h4>Удалить проект</h4>
        </template>
        <template v-slot:body>

          <h6><strong>Вы уверены, что хотите удалить проект?</strong></h6>
          <p>Все связанные данные будут удалены, это действие необратимо</p>

        </template>
        <template v-slot:footer>
          <button type="button" class="btn btn-secondary" @click="$modal('hide', 'delete_project')"
                  data-bs-dismiss="modal">Отмена
          </button>
          <button type="button" class="btn btn-danger" @click="deleteProject();$modal('hide', 'delete_project');"
                  data-bs-dismiss="modal">Удалить
          </button>
        </template>
      </modal>
    </div>

</template>

<script>
import {ProjectApi} from "@/api/projects";

export default {
  name: 'DeleteProject',
  data() {
    return {

    }
  },
  computed: {

    project_id: {
      get() {
        return this.$store.getters.currentProjectId
      },
      set(value) {
      }
    },

  },

  methods: {
    deleteProject() {
      ProjectApi.delete_project(this.project_id).then(() => {
        this.$store.commit("set_project", {})
        this.$store.dispatch("setProjectId", null)

        this.$notify({
          type: "success",
          text: 'Проект удалён'
        })

        location.pathname = '/project';
      })
    },

  }
}
</script>

<style scoped lang="scss">

</style>